<template>
	<Teleport defer to="body">
		<div
			v-if="isLoading"
			class="fixed inset-0 bg-black/50 flex items-center justify-center z-[9999]">
			<div
				class="animate-spin rounded-full border-4 border-white border-t-transparent w-16 h-16"></div>
		</div>
	</Teleport>
</template>

<script setup lang="ts">
import { useGlobalLoader } from "@/composables/useGlobalLoader";

const { isLoading } = useGlobalLoader();
</script>
